const getters = {
    getLastSuccessNotification: state => () => {
        return state.success[state.success.length - 1]
    },

    getLastInfoNotification: state => () => {
        return state.info[state.info.length - 1]
    },

    getLastWarningNotification: state => () => {
        return state.warning[state.warning.length - 1]
    },

    getLastErrorNotification: state => () => {
        return state.error[state.error.length - 1]
    }
}

export default getters
